import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { HERO_IMG_WIDE, BRAND, SUBTITLE, TAGLINE } from "@/lib/content";

export default function Hero() {
  return (
    <section className="relative md:min-h-screen flex flex-col md:flex-row md:items-center pt-16 md:pt-0" data-testid="hero-section">
      <div className="relative w-full aspect-[1264/848] md:aspect-auto md:absolute md:top-0 md:right-0 md:h-full md:w-[60%]">
        <img src={HERO_IMG_WIDE} alt="Black family with golden angel wings under the sun, moon and stars in a purple and blue sky" className="w-full h-full object-cover" data-testid="hero-image" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#070d2b] via-transparent to-transparent md:bg-gradient-to-r md:from-[#070d2b] md:via-[#070d2b]/10 md:to-transparent" />
      </div>
      <nav className="absolute top-0 inset-x-0 flex justify-between items-center px-6 md:px-12 py-6 z-10">
        <span className="font-heading tracking-[0.3em] text-xs text-gold-soft">QUEEN BOYCE</span>
        <Link to="/owner" data-testid="owner-link" className="text-xs tracking-widest text-cream/70 hover:text-gold transition-colors">OWNER</Link>
      </nav>
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1.6, ease: "easeOut" }}
        className="relative z-10 px-6 md:px-16 pt-8 md:pt-0 pb-16 md:pb-0 max-w-2xl md:w-[50%]">
        <p className="font-heading tracking-[0.35em] text-xs text-gold mb-5">WELCOME, BELOVED SOUL</p>
        <h1 className="font-display gold-text text-5xl sm:text-6xl lg:text-7xl leading-tight" data-testid="hero-title">{BRAND}</h1>
        <p className="font-heading text-base md:text-lg text-[#f7f1e1] mt-4 tracking-wide" data-testid="hero-subtitle">{SUBTITLE}</p>
        <div className="gold-line w-40 my-7" />
        <p className="italic text-2xl md:text-3xl text-gold-soft" data-testid="hero-tagline">"{TAGLINE}"</p>
        <div className="flex flex-wrap gap-4 mt-10">
          <a href="#request" data-testid="hero-request-btn" className="btn-gold rounded-full px-8 py-3.5 font-heading text-sm tracking-widest">REQUEST A SESSION</a>
          <a href="#journey" data-testid="hero-journey-btn" className="rounded-full px-8 py-3.5 font-heading text-sm tracking-widest border border-[#d4af37]/60 text-gold-soft hover:bg-[#d4af37]/10 transition-colors">MY JOURNEY</a>
        </div>
      </motion.div>
    </section>
  );
}
